import * as z from "zod";
import { gql } from "graphql-request";
import { SysSchema, SysFragment } from "./sys";

export const CountdownTimerSchema = z.object({
  sys: SysSchema,
  __typename: z.literal("CountdownTimer"),
  timerText: z.string().nullable(),
  timerEndDate: z.string().nullable(),
  timerKind: z.string().nullable(),
});

export const CountdownTimer = CountdownTimerSchema;
export type CountdownTimer = z.infer<typeof CountdownTimerSchema>;

export const CountdownTimerFragment = gql`
  fragment CountdownTimerFragment on CountdownTimer {
    sys {
      ...SysFragment
    }
    __typename
    timerText
    timerEndDate
    timerKind
  }

  ${SysFragment}
`;
